import { getThemeLabelDefaults } from '../theming/themePropertyRegistry';

/**
 * Extract labels from a theme object, applying defaults from the registry.
 * The registry (themePropertyRegistry.ts) is the single source of truth for label defaults.
 */
export default function getThemeLabels(theme) {
  const defaults = getThemeLabelDefaults();

  if (!theme) {
    return { ...defaults };
  }

  // Labels can be at theme.labels (direct) or theme.variables.labels (nested)
  const labels = theme.labels || theme.variables?.labels || {};

  const result = {};
  for (const [key, defaultVal] of Object.entries(defaults)) {
    result[key] = labels[key] || defaultVal;
  }

  return result;
}
